/**
 * LocalOrderItem entity - maps to local_order_items table.
 */

import type { EntitySchema } from '../types';

export interface LocalOrderItem {
  id: string;
  local_order_id: string;
  item_id: string | null;
  item_code: string;
  default_price: number;
  selling_price: number;
  unit_default_price: number;
  unit_selling_price: number;
  quantity: number;
  selling_type: string;
  notes: string | null;
}

export const LocalOrderItemSchema: EntitySchema<LocalOrderItem> = {
  tableName: 'local_order_items',
  columns: [
    { name: 'id', type: 'TEXT', primary: true },
    {
      name: 'local_order_id',
      type: 'TEXT',
      nullable: false,
      references: {
        table: 'local_orders',
        column: 'id',
        onDelete: 'CASCADE',
      },
    },
    { name: 'item_id', type: 'TEXT', nullable: true },
    { name: 'item_code', type: 'TEXT', nullable: false },
    { name: 'default_price', type: 'REAL', nullable: false, default: 0 },
    { name: 'selling_price', type: 'REAL', nullable: false, default: 0 },
    { name: 'unit_default_price', type: 'REAL', nullable: false, default: 0 },
    { name: 'unit_selling_price', type: 'REAL', nullable: false, default: 0 },
    { name: 'quantity', type: 'REAL', nullable: false },
    { name: 'selling_type', type: 'TEXT', nullable: false, default: 'selling' },
    { name: 'notes', type: 'TEXT', nullable: true },
  ],
  indexes: [
    { name: 'idx_local_order_items_order_id', columns: ['local_order_id'] },
  ],
};
